import { CrossSectionCanvas } from '@pages/cross-section/shared/CrossSectionCanvas';
import { ProjectCodesService } from '@shared/services/ProjectCodesService';
import Konva from 'konva';


function drawLogpoint(opts: {
    id: string,
    logpoint: any,
    isHighlighted: boolean,
    csCanvas: CrossSectionCanvas,
    onClickCallback: (logpoint, x, y) => void
}) {
    let { logpoint, isHighlighted, csCanvas, onClickCallback } = opts;
    const canvasOptions = csCanvas.canvasOptions;
    const lowestPoint = csCanvas.lowestPoint;
    const layer = csCanvas.contentLayer;
    const center = csCanvas.getCenter();
    let visible = true;

    let x = center + logpoint.x * canvasOptions.x_scale;
    let y = (csCanvas.height - canvasOptions.bottom_margin) + lowestPoint * canvasOptions.y_scale - logpoint.y * canvasOptions.y_scale + csCanvas.panY;
    let color;
    let shapes = [];

    switch (logpoint.tol) {
        case 0:
            color = 'black';
            break;
        case 1:
            color = 'red';
            break;
        case 2:
            color = 'green'
            break;
        case 4:
            color = 'blue';
            break;
        default:
            color = 'gray';
            break;
    }

    const onClick = () => {
        csCanvas.drawTooltip(x, y, getTooltipText(logpoint, null), true)
        onClickCallback(logpoint, x, y);
    }

    const onMouseOver = () => {
        csCanvas.drawTooltip(x, y - 8, getTooltipText(logpoint, null));
        csCanvas.drawSnapCursor(true, x, y);
    }

    if (x > csCanvas.width - canvasOptions.side_margin / 2 || x < canvasOptions.side_margin / 2) {
        visible = false;
    }

    shapes.push(new Konva.Line({
        visible: visible,
        name: 'logpoint',
        points: [x, y - 5, x, y + 5],
        stroke: color,
        strokeWidth: 2,
        listening: false
    }));

    shapes.push(new Konva.Line({
        visible: visible,
        name: 'logpoint',
        points: [x - 5, y, x + 5, y],
        stroke: color,
        strokeWidth: 2,
        listening: false
    }));

    if (logpoint.type === 'TOTAL_STATION') {
        shapes.push(new Konva.Circle({
            visible: visible,
            name: 'logpoint',
            x: x,
            y: y,
            stroke: color,
            strokeWidth: 1,
            radius: 4,
            listening: false
        }));
    }

    if (logpoint.type === 'VEHICLE') {
        shapes.push(new Konva.Line({
            visible: visible,
            name: 'logpoint',
            points: [x, y, x + 4, y - 3.5],
            stroke: color,
            strokeWidth: 2,
            listening: false
        }));
    }

    if (color !== 'gray') {
        let dz = isNumber(logpoint.modelDeltaZ) ? logpoint.modelDeltaZ.toFixed(2) : "";

        let text = new Konva.Text({
            visible: visible,
            name: 'logpoint_text',
            x: x,
            y: y + 10,
            text: dz,
            fontSize: 12,
            fontFamily: 'Calibri',
            fill: color
        });
        text.offsetX(text.width() / 2);

        text.on('click tap', onClick);
        text.on('mouseover', onMouseOver);
        text.on('mouseout', csCanvas.clearHoverTooltips);

        shapes.push(text);
    }

    let clickShape = new Konva.Circle({
        visible: visible,
        name: 'logpoint',
        x: x,
        y: y,
        stroke: 'transparent',
        radius: 10
    });

    if (isHighlighted) {
        let size = 15;
        let rect = new Konva.Rect({
            visible: visible,
            x: x - (size - 1) / 2,
            y: y - (size - 1) / 2,
            width: size,
            height: size,
            stroke: 'black',
            strokeWidth: 1,
            listening: false
        });
        shapes.push(rect);
    }

    clickShape.on('click tap', onClick);
    clickShape.on('mouseover', onMouseOver);
    clickShape.on('mouseout', csCanvas.clearHoverTooltips);

    shapes.push(clickShape);

    $.each(shapes, function (undefined, shape) {
        layer.add(shape);
    });

    return shapes;
}

const getTooltipText = (logpoint: any, modelName: string) => {
    let t: string = '';
    if (modelName) {
        t += modelName + "\n";
    }
    if (logpoint.pointName) {
        t += kuura.getMessage('js.cross_section.name') + ': ' + (logpoint.pointName) + '\n';
    }
    if (logpoint.number) {
        t += kuura.getMessage('js.cross_section.number') + ': ' + (logpoint.number) + '\n';
    }
    if (logpoint.code) {
        t += kuura.getMessage('js.cross_section.code') + ': ' + (ProjectCodesService.codeWithDescription(logpoint.code)) + '\n';
    }
    let pointX = isNumber(logpoint.x) ? (logpoint.x).toFixed(2) : "";
    let pointZ = isNumber(logpoint.z) ? (logpoint.z).toFixed(2) : "";
    let dz = isNumber(logpoint.modelDeltaZ) ? (logpoint.modelDeltaZ).toFixed(2) : "";
    t += kuura.getMessage('js.cross_section.b') + ': ' + pointX + '\n'
        + kuura.getMessage('js.cross_section.z') + ': ' + pointZ + '\n'
        + kuura.getMessage('js.cross_section.dz') + ': ' + dz + '\n'

    let upperLimit = isNumber(logpoint.tolerance.upperLimit) ? (logpoint.tolerance.upperLimit).toFixed(2) : "";
    let lowerLimit = isNumber(logpoint.tolerance.lowerLimit) ? (logpoint.tolerance.lowerLimit).toFixed(2) : "";

    t += kuura.getMessage('js_models.folder_tolerance_upper_limit') + ': ' + upperLimit + '\n'
        + kuura.getMessage('js_models.folder_tolerance_lower_limit') + ': ' + lowerLimit;

    return t
}

const isNumber = (n: any) => !isNaN(parseFloat(n)) && isFinite(n);

export const CrossSectionLogpoint = {
    drawLogpoint
}
